import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Preloader } from '@/store';
import {
  AtomTitle,
  AtomInput,
  MessageIcon,
  AtomSubTitle,
  LoginIcon,
  ProfileIconLogin,
  AtomButton,
} from '@/components/atoms';
import { MoleculeModalAlertRecoverPassword } from '@/components/molecules';
// import { Credential } from '../../../core/models';
import { state } from '@/store/modules/layout';
// import swal from 'sweetalert2';
// import { AxiosError } from 'axios';

export default /*@__PURE__*/_defineComponent({
  __name: 'FormConfirmEmail',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
// const route = useRoute();
const email = ref<string>('');

const listError = ref<string[]>([]);
const showModalAlert = ref<boolean>(false);
const loading = ref<boolean>(false);

const version = ref<string>('');
onMounted(() => {
  fetch('version')
    .then((response) => response.text())
    .then((csvString) => {
      version.value = csvString;
    });
});

function handleFinsh() {
  router.push({ name: 'Login' });
}
function handleSendEmail() {
  listError.value = [];

  if (!email.value) listError.value.push('email');

  if (listError.value.length > 0) return;

  loading.value = true;

  setTimeout(() => {
    showModalAlert.value = true;
    loading.value = false;
  }, 2000);

  // const auth: Credential = {
  //   acessToken: String(route.params.acessToken),
  //   email: email.value,
  // };
  Preloader.actions.time(true);
  // Authentication.actions
  //   .login(auth)
  //   .then(() => {  
  //       setTimeout(() => {
  //     router.push({ name: 'Home' });
  //   }, 2000);
  //   })
  //   .catch((f: AxiosError) => {
  //     if (f.response.status == 401) {
  //       swal.fire({
  //         title: 'Ops.',
  //         text: 'Usuário ou senha inválidos',
  //         icon: 'warning',
  //       });
  //     } else {
  //       swal.fire({
  //         title: 'Ops...',
  //         text: 'Erro inesperado no sistema, favor entrar em contato com o suporte',
  //         icon: 'error',
  //       });
  //     }
  //   })
  //   .finally(() => {
  //     Preloader.actions.time(false);
          // loading.value = false;
  //   });
}

const __returned__ = { router, email, listError, showModalAlert, loading, version, handleFinsh, handleSendEmail, get AtomTitle() { return AtomTitle }, get AtomInput() { return AtomInput }, get MessageIcon() { return MessageIcon }, get AtomSubTitle() { return AtomSubTitle }, get LoginIcon() { return LoginIcon }, get ProfileIconLogin() { return ProfileIconLogin }, get AtomButton() { return AtomButton }, get MoleculeModalAlertRecoverPassword() { return MoleculeModalAlertRecoverPassword }, get state() { return state } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})